import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import axios from "axios";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

const SmartphoneDeals = () => {
  const [smartphones, setSmartphones] = useState([]);

  useEffect(() => {
    const fetchAll = async () => {
      try {
        // Categories
        // const catRes = await axios.get(
        //   "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_main_category"
        // );
        // if (catRes.data.status === "true" || catRes.data.status === true) {
        //   setCategories(catRes.data.row);
        // }

        // // Subcategories
        // const subRes = await axios.get(
        //   "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_main_subcategory"
        // );
        // if (subRes.data.status === "true" || subRes.data.status === true) {
        //   setSubcategories(subRes.data.row);
        // }

        // Products
const prodRes = await axios.get(
  "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_create_product"
);

if (prodRes.data.status === true || prodRes.data.status === "true") {
  const filtered = prodRes.data.data.filter(
    (item) => item.product_status === "Special Offers" &&
              item.admin_approval === "approval" &&
              item.paid_approval === "yes"
  );
  setSmartphones(filtered);
} else {
  toast.error("Failed to fetch product list!");
}

      } catch (error) {
        console.error("Error fetching:", error);
        toast.error("Error fetching product list.");
      }
    };

    fetchAll();
  }, []);

  

  return (
    <div className="container py-4 bg-white mb-3">
  {/* Header */}
  <div className="d-flex justify-content-between align-items-center mb-3 bg-white">
    <h3 className="fw-bold bg-white">Special Offers</h3>
   <Link
               to="/products"
               state={{ categoryId: 1 }} // 🔥 Electronics ID
               className="text-decoration-none"
               style={{ color: "#ff7043" }}
             >
               View All <i className="bi bi-chevron-right"></i>
             </Link> 
  </div>

  {/* Smartphone cards with Bootstrap grid */}
  <div className="bg-white">
    {smartphones.length > 0 && (
  <div className="arrivals-grid-layout">

    {smartphones.map((phone, index) => (
      <Link
        key={index}
        to={`/model/${phone.product_id}`}
        style={{ textDecoration: "none" }}
      >
        <div className="arrivals-item-card">

          {/* IMAGE */}
          <div className="arrivals-visual">
            <img
              src={`https://cyberathon.com/multivendor/${phone.multi_image?.[0]}`}
              alt={phone.product_name}
              onError={(e) => (e.target.src = "/img/placeholder.png")}
            />

            {/* <div className="arrivals-new-badge">NEW</div> */}
            {/* <div className="arrivals-fav">♡</div> */}

            <div className="arrivals-add-layer">
              <button className="arrivals-btn-add">QUICK ADD</button>
            </div>
          </div>

          {/* CONTENT */}
          <div className="arrivals-content">
            <h3 className="arrivals-product-title">
              {phone.product_name}
            </h3>

            <div className="arrivals-price-info">
              <span className="arrivals-price-new">
                ₹{phone.current_price}
              </span>
              <span className="arrivals-price-old">
                ₹{phone.old_price}
              </span>
            </div>

            <p style={{ color: "green", fontSize: "13px", marginTop: "5px" }}>
              {phone.discount}% OFF
            </p>
          </div>

        </div>
      </Link>
    ))}

  </div>
)}
  </div>
</div>

  );
};

export default SmartphoneDeals;
